import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "p-m-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: _ctx.title,
    visible: _ctx.visible,
    modal: true,
    contentStyle: _ctx.functionsCatalogDetailDescriptor.warningDialog.style,
    class: "p-fluid kn-dialog--toolbar--primary",
    closable: false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Message, {
          class: "p-m-2",
          severity: "warn",
          closable: false,
          style: _ctx.functionsCatalogDetailDescriptor.styles.message
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.missingFields, (field, index) => {
              return (_openBlock(), _createBlock("p", {
                class: "p-m-2",
                key: index
              }, _toDisplayString(field), 1))
            }), 128))
          ]),
          _: 1
        }, 8, ["style"])
      ])
    ]),
    _: 1
  }, 8, ["header", "visible", "contentStyle"]))
}